import React from "react";
import { cn } from "../../../../helpers/utils/css-utils";

const Switch = React.forwardRef(
  ({ id = "toggle1", className, label, ...props }, ref) => {
    return (
      <div className="flex items-center gap-2.5">
        <input
          ref={ref}
          id={id}
          type="checkbox"
          className={cn("peer sr-only", className)}
          {...props}
        />

        {/*
          Track + knob. The knob is styled from the label via peer-checked so the
          state actually reaches it (a nested child can't match its own parent's peer).
        */}
        <label
          htmlFor={id}
          className="relative h-6 w-11 shrink-0 cursor-pointer rounded-full bg-gray-200 transition-colors duration-200
            after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5 after:rounded-full after:bg-white
            after:shadow-sm after:transition-transform after:duration-200 after:content-['']
            peer-checked:bg-brand-lime peer-checked:after:translate-x-5
            peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-2"
        />

        {label ? (
          <label
            htmlFor={id}
            className="cursor-pointer select-none text-sm text-gray-600"
          >
            {label}
          </label>
        ) : null}
      </div>
    );
  }
);

export { Switch };
